import { render, staticRenderFns } from "./postList.vue?vue&type=template&id=52fcc061&scoped=true"
import script from "./postList.vue?vue&type=script&lang=js"
export * from "./postList.vue?vue&type=script&lang=js"
import style0 from "./postList.vue?vue&type=style&index=0&id=52fcc061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fcc061",
  null
  
)

export default component.exports